<div class="unauth-wrapper">

    <div class="un_auth">
        <h1>You do not currently have access to AI Advisor</h1>
    </div>
    <div class="unauth-panel">
        <h2 class="decorated"><span>About AIAdvisor</span></h2>
        <p class="description">The application aims to create a solution that assists in product launches with
            summarization of extrenal content, provides efficient information search from internal J&J approved content,
            and assists with product training to serve customer needs.</p>
    </div>
    <div class="unauth-panel unauth-panel-left">
        <h2 class="decorated"><span class="role-user">Roles/User on AIAdvisor Application</span></h2>
        <div class="product-wrapper">
            <mat-tab-group>
                <mat-tab *ngFor="let segment of segments" [label]="segment.segment_name">
                    <div class="business-unit-cards">
                        <div *ngFor="let bu of segment.business_units" class="business-unit-card">
                            <h2>{{ bu.name }}</h2>
                            <div class="customs-select">
                                <div class="select-heading-txt">Region</div>
                                <mat-form-field appearance="fill">
                                    <mat-label>{{getRegionDisplayLabel(bu, selectedRegions[bu.code])}}</mat-label>
                                    <mat-select [value]="selectedRegions[bu.code]"
                                        (selectionChange)="onRegionChange(bu.code, $event.value)" multiple>
                                        <mat-option *ngFor="let region of bu.regions" [value]="region.name">
                                            <mat-checkbox class="mat-option-pseudo-checkbox"
                                                [checked]="selectedRegions[bu.code]?.includes(region.name)"
                                                (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                                                (change)="onRegionChange(bu.code, region.name)">
                                            </mat-checkbox>
                                            {{ region.label || region.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <button mat-button (click)="onAccessRequest(bu.code)" class="bttn btn-white">Request
                                Access</button>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>